import { render, staticRenderFns } from "./Erp6SaleBaseSalesTeamEdit.vue?vue&type=template&id=a26f4f6a&scoped=true&"
import script from "./Erp6SaleBaseSalesTeamEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseSalesTeamEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseSalesTeamEdit.vue?vue&type=style&index=0&id=a26f4f6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f4f6a",
  null
  
)

export default component.exports